exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Microphone-module__wrapper___2GdMi{position:relative;width:40px;height:40px}.Microphone-module__wrapper___2GdMi button img{height:100%}.Microphone-module__wrapper___2GdMi .Microphone-module__progress___2HEqE{position:absolute;background-color:#f44e4e;height:100%;width:100%;right:0;top:0}.Microphone-module__wrapper___2GdMi .Microphone-module__red___3t9tC{color:#f44e4e}.Microphone-module__wrapper___2GdMi .Microphone-module__blue___2xmkj{color:#1368e5}.Microphone-module__wrapper___2GdMi .Microphone-module__send-recording___1_3AR{opacity:.5}.Microphone-module__wrapper___2GdMi .Microphone-module__send-recording___1_3AR.Microphone-module__recordingInMemory___AY-Jx{opacity:1}", ""]);

// exports
exports.locals = {
	"wrapper": "Microphone-module__wrapper___2GdMi",
	"progress": "Microphone-module__progress___2HEqE",
	"red": "Microphone-module__red___3t9tC",
	"blue": "Microphone-module__blue___2xmkj",
	"send-recording": "Microphone-module__send-recording___1_3AR",
	"recordingInMemory": "Microphone-module__recordingInMemory___AY-Jx"
};